import z from 'zod';
export const reportFailedWebhookSchema = z.looseObject({
    type: z.literal('report-failed'),
    projectId: z.string(),
    reportId: z.string(),
    code: z.string(),
    message: z.string(),
});
//# sourceMappingURL=report-failed.webhook.js.map